/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */
import type {
  AddressDTO,
  AppointmentConfirmationRequestDTO,
  AppointmentDTO,
  AppointmentDetailsDTO,
  AppointmentReminderCallResponseDTO,
  AssociateInsuranceCardRequestDTO,
  CommuniqueByPatientInfoRequestDTO,
  CommuniqueVisibilityFlagsResponseDTO,
  ConfirmAppointmentCommuniqueResponseDTO,
  ConsentFormsCommuniqueDTO,
  DosespotConsentByPatientDTO,
  ERxDrugAllergySearchResponseDTO,
  ERxMedicationSearchResponseDTO,
  ERxPharmacySearchResponseDTO,
  EnsureAppointmentFormWorkflowResponseDTO,
  FormFieldAssignee,
  FormWorkflowCompletionRequestDTO,
  FormWorkflowWithTransitionSuccessMessageResponseDTO,
  FormsRenderingMetadataResponseDTO,
  FormsResponseDTO,
  GetApiAddressGetGeoCodeByAddressParams,
  GetApiBillingGetInvoiceSummaryParams,
  GetApiCHGetFavoriteInsurancesByOrgParams,
  GetApiCHSearchInsuranceByOrgParams,
  GetApiCHSearchInsuranceParams,
  GetApiCommunicationGetAppointmentCommuniqueByTokenParams,
  GetApiCommunicationGetIntakeFlagsByTokenParams,
  GetApiERxDrugAllergySearchParams,
  GetApiERxMedicationSearchParams,
  GetApiERxPharmacySearchParams,
  GetApiEncounterGetAppointmentsByDateParams,
  GetApiIntakeAppProviderSearchExternalProviderParams,
  GetApiOrganizationGetOrgByPatientIdParams,
  GetApiRTMGetCheckInQuestionsParams,
  GetApiRTMGetEnrollmentInfoParams,
  GetApiRTMGetStatusByPatientIdParams,
  GetPatientJoinUrlRequestDTO,
  ISyncPatientResult,
  InsuranceAttachmentDTO,
  InsuranceDTO,
  InsuranceSettingsDTO,
  IntakeAppTokenByDemographicsRequest,
  IntakeAppTokenByLinkRequest,
  IntakeAppTokenResponse,
  ModifyAppointmentStatusResponseDTO,
  MultiMediaDeleteDTO,
  MultiMediaResponseDTO,
  NPISearchResponseDTO,
  None,
  OrgBannerPictureByTokenRequestDTO,
  OrganizationByIntakeRequestDTO,
  OrganizationByIntakeResponseDTO,
  OrganizationDTO,
  PCCProgram,
  PatientDOBDTO,
  PatientDTO,
  PatientInfoCommuniqueDTO,
  PatientInsurancesRequestDTO,
  PatientMedicalHistoryRequestDTO,
  PatientMultiMediaResponseDTO,
  PatientMultiMediaUploadDTO,
  PatientPCCItemsDTO,
  PatientPharmacyAllergyMedicationRequestDTO,
  PatientWithHPIAttributesDTO,
  PayerEntryDTO,
  PostApiAppointmentReminderAgentCallForAppointmentReminderParams,
  PostApiCommunicationEnsureFormWorkflowForAppointmentCommuniqueParams,
  PostApiRTMCompleteEnrollmentParams,
  RTMAnswers,
  RTMEnrollmentInfoResponse,
  RTMPatientStatusResponseDTO,
  RTMQuestionsResponse,
  ReasonForVisitDTO,
  SettingsDTO,
  SquareInvoiceSummaryResponseDTO,
  SyncInsuranceAttachmentsRequestDTO,
  TelehealthPatientJoinInfoDTO,
  TempoAnswers,
  TempoQuestionsResponse,
  TempoSubmitAnswerResponseDto,
  UploadAndAssociateInsuranceCardRequestDTO,
  UpsertInsuranceRequestDTO
} from './dtos';

import { sendRequest } from '../services/httpClient';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getApiAddressGetGeoCodeByAddress = (
    params?: GetApiAddressGetGeoCodeByAddressParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<AddressDTO>(
      {url: `/api/Address/GetGeoCodeByAddress`, method: 'GET',
        params
    },
      options);
    }
  
export const postApiAppointmentReminderAgentCallForAppointmentReminder = (
    params?: PostApiAppointmentReminderAgentCallForAppointmentReminderParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<AppointmentReminderCallResponseDTO>(
      {url: `/api/AppointmentReminderAgent/CallForAppointmentReminder`, method: 'POST',
        params
    },
      options);
    }
  
export const postApiIntakeAppAuthGetTokenByLink = (
    intakeAppTokenByLinkRequest: IntakeAppTokenByLinkRequest,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<IntakeAppTokenResponse>(
      {url: `/api/IntakeApp/Auth/GetTokenByLink`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: intakeAppTokenByLinkRequest
    },
      options);
    }
  
export const postApiIntakeAppAuthGetTokenByDemographics = (
    intakeAppTokenByDemographicsRequest: IntakeAppTokenByDemographicsRequest,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<IntakeAppTokenResponse>(
      {url: `/api/IntakeApp/Auth/GetTokenByDemographics`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: intakeAppTokenByDemographicsRequest
    },
      options);
    }
  
export const postApiIntakeAppAuthGetBannerPictureByToken = (
    orgBannerPictureByTokenRequestDTO: OrgBannerPictureByTokenRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/IntakeApp/Auth/GetBannerPictureByToken`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orgBannerPictureByTokenRequestDTO
    },
      options);
    }
  
export const getApiBillingGetInvoiceSummary = (
    params?: GetApiBillingGetInvoiceSummaryParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<SquareInvoiceSummaryResponseDTO>(
      {url: `/api/Billing/GetInvoiceSummary`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiCHSearchInsurance = (
    params?: GetApiCHSearchInsuranceParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/CH/SearchInsurance`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiCHSearchInsuranceByOrg = (
    params?: GetApiCHSearchInsuranceByOrgParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/CH/SearchInsuranceByOrg`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiCHGetFavoriteInsurancesByOrg = (
    params?: GetApiCHGetFavoriteInsurancesByOrgParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PayerEntryDTO[]>(
      {url: `/api/CH/GetFavoriteInsurancesByOrg`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiCommunicationGetPatientInfoCommuniqueByTokenToken = (
    token: string,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientInfoCommuniqueDTO>(
      {url: `/api/Communication/GetPatientInfoCommuniqueByToken/${token}`, method: 'GET'
    },
      options);
    }
  
export const getApiCommunicationGetAppointmentCommuniqueByToken = (
    params?: GetApiCommunicationGetAppointmentCommuniqueByTokenParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ConfirmAppointmentCommuniqueResponseDTO>(
      {url: `/api/Communication/GetAppointmentCommuniqueByToken`, method: 'GET',
        params
    },
      options);
    }
  
export const postApiCommunicationEnsureFormWorkflowForAppointmentCommunique = (
    params?: PostApiCommunicationEnsureFormWorkflowForAppointmentCommuniqueParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<EnsureAppointmentFormWorkflowResponseDTO>(
      {url: `/api/Communication/EnsureFormWorkflowForAppointmentCommunique`, method: 'POST',
        params
    },
      options);
    }
  
export const postApiCommunicationGetOrCreateCommuniqueByPatientInfoAndUpdateAppointment = (
    communiqueByPatientInfoRequestDTO: CommuniqueByPatientInfoRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ConfirmAppointmentCommuniqueResponseDTO | void>(
      {url: `/api/Communication/GetOrCreateCommuniqueByPatientInfoAndUpdateAppointment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: communiqueByPatientInfoRequestDTO
    },
      options);
    }
  
export const getApiCommunicationGetIntakeFlagsByToken = (
    params?: GetApiCommunicationGetIntakeFlagsByTokenParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<CommuniqueVisibilityFlagsResponseDTO>(
      {url: `/api/Communication/GetIntakeFlagsByToken`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiCommunicationGetConsentFormCommuniqueByTokenToken = (
    token: string,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ConsentFormsCommuniqueDTO>(
      {url: `/api/Communication/GetConsentFormCommuniqueByToken/${token}`, method: 'GET'
    },
      options);
    }
  
export const getApiEncounterGetAppointmentsByDate = (
    params?: GetApiEncounterGetAppointmentsByDateParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<AppointmentDTO[]>(
      {url: `/api/Encounter/GetAppointmentsByDate`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiEncounterGetAppointmentDetailsByAppointmentIdAppointmentId = (
    appointmentId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<AppointmentDetailsDTO>(
      {url: `/api/Encounter/GetAppointmentDetailsByAppointmentId/${appointmentId}`, method: 'GET'
    },
      options);
    }
  
export const postApiEncounterSetAppointmentConfirmation = (
    appointmentConfirmationRequestDTO: AppointmentConfirmationRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ModifyAppointmentStatusResponseDTO>(
      {url: `/api/Encounter/SetAppointmentConfirmation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: appointmentConfirmationRequestDTO
    },
      options);
    }
  
export const getApiERxMedicationSearch = (
    params?: GetApiERxMedicationSearchParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ERxMedicationSearchResponseDTO>(
      {url: `/api/eRx/MedicationSearch`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiERxDrugAllergySearch = (
    params?: GetApiERxDrugAllergySearchParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ERxDrugAllergySearchResponseDTO>(
      {url: `/api/eRx/DrugAllergySearch`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiERxPharmacySearch = (
    params?: GetApiERxPharmacySearchParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ERxPharmacySearchResponseDTO>(
      {url: `/api/eRx/PharmacySearch`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssignee = (
    formWorkflowId: number,
    assignee: FormFieldAssignee,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<FormsRenderingMetadataResponseDTO>(
      {url: `/api/FormWorkflow/GetRenderingMetadata/${formWorkflowId}/${assignee}`, method: 'GET'
    },
      options);
    }
  
export const postApiFormWorkflowCompletePatientStep = (
    formWorkflowCompletionRequestDTO: FormWorkflowCompletionRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<FormWorkflowWithTransitionSuccessMessageResponseDTO>(
      {url: `/api/FormWorkflow/CompletePatientStep`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: formWorkflowCompletionRequestDTO
    },
      options);
    }
  
export const getApiFormWorkflowGetWorkflowPdfsFormWorkflowId = (
    formWorkflowId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/FormWorkflow/GetWorkflowPdfs/${formWorkflowId}`, method: 'GET'
    },
      options);
    }
  
export const postApiMultimediaDeleteMultiMedia = (
    multiMediaDeleteDTO: MultiMediaDeleteDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<None>(
      {url: `/api/Multimedia/DeleteMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: multiMediaDeleteDTO
    },
      options);
    }
  
export const postApiMultimediaPostPatientMultiMedia = (
    patientMultiMediaUploadDTO: PatientMultiMediaUploadDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientMultiMediaResponseDTO>(
      {url: `/api/Multimedia/PostPatientMultiMedia`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMultiMediaUploadDTO
    },
      options);
    }
  
export const getApiMultimediaGetOrgBannerPictureByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetOrgBannerPictureByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }
  
export const getApiMultimediaGetBillingMultiMediaByIdForPatientBillingMultiMediaId = (
    billingMultiMediaId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetBillingMultiMediaByIdForPatient/${billingMultiMediaId}`, method: 'GET'
    },
      options);
    }
  
export const getApiMultimediaGetPatientMultiMediaByIdPatientMultiMediaId = (
    patientMultiMediaId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetPatientMultiMediaById/${patientMultiMediaId}`, method: 'GET'
    },
      options);
    }
  
export const getApiMultimediaGetPatientMultimediaByTypePatientIdMultimediaType = (
    patientId: number,
    multimediaType: string,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Multimedia/GetPatientMultimediaByType/${patientId}/${multimediaType}`, method: 'GET'
    },
      options);
    }
  
export const getApiOrganizationGetOrgByPatientId = (
    params?: GetApiOrganizationGetOrgByPatientIdParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<OrganizationDTO>(
      {url: `/api/Organization/GetOrgByPatientId`, method: 'GET',
        params
    },
      options);
    }
  
export const postApiOrganizationGetOrgByIpadBaseIntakeUrl = (
    organizationByIntakeRequestDTO: OrganizationByIntakeRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<OrganizationByIntakeResponseDTO>(
      {url: `/api/Organization/GetOrgByIpadBaseIntakeUrl`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationByIntakeRequestDTO
    },
      options);
    }
  
export const getApiPatientGetPatientByIdId = (
    id: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/GetPatientById/${id}`, method: 'GET'
    },
      options);
    }
  
export const getApiPatientGetPCCItemsByPatientIdPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientPCCItemsDTO>(
      {url: `/api/Patient/GetPCCItemsByPatientId/${patientId}`, method: 'GET'
    },
      options);
    }
  
export const getApiPatientGetPatientByIdWithPharmacyMedicationAndAllergyId = (
    id: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/GetPatientByIdWithPharmacyMedicationAndAllergy/${id}`, method: 'GET'
    },
      options);
    }
  
export const postApiPatientAddPatientMedicalHistory = (
    patientMedicalHistoryRequestDTO: PatientMedicalHistoryRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/AddPatientMedicalHistory`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientMedicalHistoryRequestDTO
    },
      options);
    }
  
export const postApiPatientAddPatientPharmacyAllergyAndMedication = (
    patientPharmacyAllergyMedicationRequestDTO: PatientPharmacyAllergyMedicationRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<ISyncPatientResult>(
      {url: `/api/Patient/AddPatientPharmacyAllergyAndMedication`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientPharmacyAllergyMedicationRequestDTO
    },
      options);
    }
  
export const postApiPatientAddInsurance = (
    upsertInsuranceRequestDTO: UpsertInsuranceRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<InsuranceDTO>(
      {url: `/api/Patient/AddInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: upsertInsuranceRequestDTO
    },
      options);
    }
  
export const putApiPatientUpdateInsurance = (
    upsertInsuranceRequestDTO: UpsertInsuranceRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<InsuranceDTO>(
      {url: `/api/Patient/UpdateInsurance`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertInsuranceRequestDTO
    },
      options);
    }
  
export const deleteApiPatientDeleteInsuranceInsuranceId = (
    insuranceId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<void>(
      {url: `/api/Patient/DeleteInsurance/${insuranceId}`, method: 'DELETE'
    },
      options);
    }
  
export const getApiPatientGetUnassociatedInsuranceCardsPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<MultiMediaResponseDTO>(
      {url: `/api/Patient/GetUnassociatedInsuranceCards/${patientId}`, method: 'GET'
    },
      options);
    }
  
export const getApiPatientGetInsuranceAttachmentsInsuranceId = (
    insuranceId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<InsuranceAttachmentDTO[]>(
      {url: `/api/Patient/GetInsuranceAttachments/${insuranceId}`, method: 'GET'
    },
      options);
    }
  
export const postApiPatientUploadAndAssociateInsuranceCardWithInsurance = (
    uploadAndAssociateInsuranceCardRequestDTO: UploadAndAssociateInsuranceCardRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<InsuranceAttachmentDTO>(
      {url: `/api/Patient/UploadAndAssociateInsuranceCardWithInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: uploadAndAssociateInsuranceCardRequestDTO
    },
      options);
    }
  
export const postApiPatientAssociateInsuranceCardWithInsurance = (
    associateInsuranceCardRequestDTO: AssociateInsuranceCardRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<InsuranceAttachmentDTO>(
      {url: `/api/Patient/AssociateInsuranceCardWithInsurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: associateInsuranceCardRequestDTO
    },
      options);
    }
  
export const postApiPatientSyncInsuranceAttachments = (
    syncInsuranceAttachmentsRequestDTO: SyncInsuranceAttachmentsRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<InsuranceAttachmentDTO[]>(
      {url: `/api/Patient/SyncInsuranceAttachments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: syncInsuranceAttachmentsRequestDTO
    },
      options);
    }
  
export const postApiPatientAddPatientInsurances = (
    patientInsurancesRequestDTO: PatientInsurancesRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/AddPatientInsurances`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientInsurancesRequestDTO
    },
      options);
    }
  
export const postApiPatientAddReasonForVisit = (
    reasonForVisitDTO: ReasonForVisitDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientDTO>(
      {url: `/api/Patient/AddReasonForVisit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reasonForVisitDTO
    },
      options);
    }
  
export const getApiPatientGetSymptomsFromImmediatePastVisitPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PatientWithHPIAttributesDTO>(
      {url: `/api/Patient/GetSymptomsFromImmediatePastVisit/${patientId}`, method: 'GET'
    },
      options);
    }
  
export const getApiPatientGetAgreementFormsForPatientPatientId = (
    patientId: number,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<FormsResponseDTO>(
      {url: `/api/Patient/GetAgreementFormsForPatient/${patientId}`, method: 'GET'
    },
      options);
    }
  
export const postApiPatientSubmitDosespotConsentForm = (
    dosespotConsentByPatientDTO: DosespotConsentByPatientDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<void>(
      {url: `/api/Patient/SubmitDosespotConsentForm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dosespotConsentByPatientDTO
    },
      options);
    }
  
export const postApiPatientVerifyPatientDOBById = (
    patientDOBDTO: PatientDOBDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<None | void>(
      {url: `/api/Patient/VerifyPatientDOBById`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: patientDOBDTO
    },
      options);
    }
  
export const getApiPCCConsentGetEnabledPrograms = (
    
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<PCCProgram[]>(
      {url: `/api/PCCConsent/GetEnabledPrograms`, method: 'GET'
    },
      options);
    }
  
export const getApiIntakeAppProviderSearchExternalProvider = (
    params?: GetApiIntakeAppProviderSearchExternalProviderParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<NPISearchResponseDTO>(
      {url: `/api/IntakeApp/Provider/SearchExternalProvider`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiRTMGetStatusByPatientId = (
    params?: GetApiRTMGetStatusByPatientIdParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<RTMPatientStatusResponseDTO>(
      {url: `/api/RTM/GetStatusByPatientId`, method: 'GET',
        params
    },
      options);
    }
  
export const getApiRTMGetEnrollmentInfo = (
    params?: GetApiRTMGetEnrollmentInfoParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<RTMEnrollmentInfoResponse>(
      {url: `/api/RTM/GetEnrollmentInfo`, method: 'GET',
        params
    },
      options);
    }
  
export const postApiRTMCompleteEnrollment = (
    params?: PostApiRTMCompleteEnrollmentParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<None>(
      {url: `/api/RTM/CompleteEnrollment`, method: 'POST',
        params
    },
      options);
    }
  
export const getApiRTMGetCheckInQuestions = (
    params?: GetApiRTMGetCheckInQuestionsParams,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<RTMQuestionsResponse>(
      {url: `/api/RTM/GetCheckInQuestions`, method: 'GET',
        params
    },
      options);
    }
  
export const postApiRTMSubmitCheckInAnswers = (
    rTMAnswers: RTMAnswers,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<None>(
      {url: `/api/RTM/SubmitCheckInAnswers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rTMAnswers
    },
      options);
    }
  
export const getApiSettingsGetIntakeFormSettings = (
    
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<SettingsDTO>(
      {url: `/api/Settings/GetIntakeFormSettings`, method: 'GET'
    },
      options);
    }
  
export const getApiSettingsGetInsuranceSettings = (
    
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<InsuranceSettingsDTO>(
      {url: `/api/Settings/GetInsuranceSettings`, method: 'GET'
    },
      options);
    }
  
export const postApiTelehealthGetPatientJoinInfo = (
    getPatientJoinUrlRequestDTO: GetPatientJoinUrlRequestDTO,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<TelehealthPatientJoinInfoDTO>(
      {url: `/api/Telehealth/GetPatientJoinInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getPatientJoinUrlRequestDTO
    },
      options);
    }
  
export const getApiTempoTokenGetQuestions = (
    token: string,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<TempoQuestionsResponse>(
      {url: `/api/Tempo/${token}/GetQuestions`, method: 'GET'
    },
      options);
    }
  
export const postApiTempoTokenSubmitAnswers = (
    token: string,
    tempoAnswers: TempoAnswers,
 options?: SecondParameter<typeof sendRequest>,) => {
      return sendRequest<TempoSubmitAnswerResponseDto>(
      {url: `/api/Tempo/${token}/SubmitAnswers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tempoAnswers
    },
      options);
    }
  
export type GetApiAddressGetGeoCodeByAddressResult = NonNullable<Awaited<ReturnType<typeof getApiAddressGetGeoCodeByAddress>>>
export type PostApiAppointmentReminderAgentCallForAppointmentReminderResult = NonNullable<Awaited<ReturnType<typeof postApiAppointmentReminderAgentCallForAppointmentReminder>>>
export type PostApiIntakeAppAuthGetTokenByLinkResult = NonNullable<Awaited<ReturnType<typeof postApiIntakeAppAuthGetTokenByLink>>>
export type PostApiIntakeAppAuthGetTokenByDemographicsResult = NonNullable<Awaited<ReturnType<typeof postApiIntakeAppAuthGetTokenByDemographics>>>
export type PostApiIntakeAppAuthGetBannerPictureByTokenResult = NonNullable<Awaited<ReturnType<typeof postApiIntakeAppAuthGetBannerPictureByToken>>>
export type GetApiBillingGetInvoiceSummaryResult = NonNullable<Awaited<ReturnType<typeof getApiBillingGetInvoiceSummary>>>
export type GetApiCHSearchInsuranceResult = NonNullable<Awaited<ReturnType<typeof getApiCHSearchInsurance>>>
export type GetApiCHSearchInsuranceByOrgResult = NonNullable<Awaited<ReturnType<typeof getApiCHSearchInsuranceByOrg>>>
export type GetApiCHGetFavoriteInsurancesByOrgResult = NonNullable<Awaited<ReturnType<typeof getApiCHGetFavoriteInsurancesByOrg>>>
export type GetApiCommunicationGetPatientInfoCommuniqueByTokenTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetPatientInfoCommuniqueByTokenToken>>>
export type GetApiCommunicationGetAppointmentCommuniqueByTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetAppointmentCommuniqueByToken>>>
export type PostApiCommunicationEnsureFormWorkflowForAppointmentCommuniqueResult = NonNullable<Awaited<ReturnType<typeof postApiCommunicationEnsureFormWorkflowForAppointmentCommunique>>>
export type PostApiCommunicationGetOrCreateCommuniqueByPatientInfoAndUpdateAppointmentResult = NonNullable<Awaited<ReturnType<typeof postApiCommunicationGetOrCreateCommuniqueByPatientInfoAndUpdateAppointment>>>
export type GetApiCommunicationGetIntakeFlagsByTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetIntakeFlagsByToken>>>
export type GetApiCommunicationGetConsentFormCommuniqueByTokenTokenResult = NonNullable<Awaited<ReturnType<typeof getApiCommunicationGetConsentFormCommuniqueByTokenToken>>>
export type GetApiEncounterGetAppointmentsByDateResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetAppointmentsByDate>>>
export type GetApiEncounterGetAppointmentDetailsByAppointmentIdAppointmentIdResult = NonNullable<Awaited<ReturnType<typeof getApiEncounterGetAppointmentDetailsByAppointmentIdAppointmentId>>>
export type PostApiEncounterSetAppointmentConfirmationResult = NonNullable<Awaited<ReturnType<typeof postApiEncounterSetAppointmentConfirmation>>>
export type GetApiERxMedicationSearchResult = NonNullable<Awaited<ReturnType<typeof getApiERxMedicationSearch>>>
export type GetApiERxDrugAllergySearchResult = NonNullable<Awaited<ReturnType<typeof getApiERxDrugAllergySearch>>>
export type GetApiERxPharmacySearchResult = NonNullable<Awaited<ReturnType<typeof getApiERxPharmacySearch>>>
export type GetApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssigneeResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetRenderingMetadataFormWorkflowIdAssignee>>>
export type PostApiFormWorkflowCompletePatientStepResult = NonNullable<Awaited<ReturnType<typeof postApiFormWorkflowCompletePatientStep>>>
export type GetApiFormWorkflowGetWorkflowPdfsFormWorkflowIdResult = NonNullable<Awaited<ReturnType<typeof getApiFormWorkflowGetWorkflowPdfsFormWorkflowId>>>
export type PostApiMultimediaDeleteMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaDeleteMultiMedia>>>
export type PostApiMultimediaPostPatientMultiMediaResult = NonNullable<Awaited<ReturnType<typeof postApiMultimediaPostPatientMultiMedia>>>
export type GetApiMultimediaGetOrgBannerPictureByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetOrgBannerPictureByPatientIdPatientId>>>
export type GetApiMultimediaGetBillingMultiMediaByIdForPatientBillingMultiMediaIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetBillingMultiMediaByIdForPatientBillingMultiMediaId>>>
export type GetApiMultimediaGetPatientMultiMediaByIdPatientMultiMediaIdResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetPatientMultiMediaByIdPatientMultiMediaId>>>
export type GetApiMultimediaGetPatientMultimediaByTypePatientIdMultimediaTypeResult = NonNullable<Awaited<ReturnType<typeof getApiMultimediaGetPatientMultimediaByTypePatientIdMultimediaType>>>
export type GetApiOrganizationGetOrgByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiOrganizationGetOrgByPatientId>>>
export type PostApiOrganizationGetOrgByIpadBaseIntakeUrlResult = NonNullable<Awaited<ReturnType<typeof postApiOrganizationGetOrgByIpadBaseIntakeUrl>>>
export type GetApiPatientGetPatientByIdIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientByIdId>>>
export type GetApiPatientGetPCCItemsByPatientIdPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPCCItemsByPatientIdPatientId>>>
export type GetApiPatientGetPatientByIdWithPharmacyMedicationAndAllergyIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetPatientByIdWithPharmacyMedicationAndAllergyId>>>
export type PostApiPatientAddPatientMedicalHistoryResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddPatientMedicalHistory>>>
export type PostApiPatientAddPatientPharmacyAllergyAndMedicationResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddPatientPharmacyAllergyAndMedication>>>
export type PostApiPatientAddInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddInsurance>>>
export type PutApiPatientUpdateInsuranceResult = NonNullable<Awaited<ReturnType<typeof putApiPatientUpdateInsurance>>>
export type DeleteApiPatientDeleteInsuranceInsuranceIdResult = NonNullable<Awaited<ReturnType<typeof deleteApiPatientDeleteInsuranceInsuranceId>>>
export type GetApiPatientGetUnassociatedInsuranceCardsPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetUnassociatedInsuranceCardsPatientId>>>
export type GetApiPatientGetInsuranceAttachmentsInsuranceIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetInsuranceAttachmentsInsuranceId>>>
export type PostApiPatientUploadAndAssociateInsuranceCardWithInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientUploadAndAssociateInsuranceCardWithInsurance>>>
export type PostApiPatientAssociateInsuranceCardWithInsuranceResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAssociateInsuranceCardWithInsurance>>>
export type PostApiPatientSyncInsuranceAttachmentsResult = NonNullable<Awaited<ReturnType<typeof postApiPatientSyncInsuranceAttachments>>>
export type PostApiPatientAddPatientInsurancesResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddPatientInsurances>>>
export type PostApiPatientAddReasonForVisitResult = NonNullable<Awaited<ReturnType<typeof postApiPatientAddReasonForVisit>>>
export type GetApiPatientGetSymptomsFromImmediatePastVisitPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetSymptomsFromImmediatePastVisitPatientId>>>
export type GetApiPatientGetAgreementFormsForPatientPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiPatientGetAgreementFormsForPatientPatientId>>>
export type PostApiPatientSubmitDosespotConsentFormResult = NonNullable<Awaited<ReturnType<typeof postApiPatientSubmitDosespotConsentForm>>>
export type PostApiPatientVerifyPatientDOBByIdResult = NonNullable<Awaited<ReturnType<typeof postApiPatientVerifyPatientDOBById>>>
export type GetApiPCCConsentGetEnabledProgramsResult = NonNullable<Awaited<ReturnType<typeof getApiPCCConsentGetEnabledPrograms>>>
export type GetApiIntakeAppProviderSearchExternalProviderResult = NonNullable<Awaited<ReturnType<typeof getApiIntakeAppProviderSearchExternalProvider>>>
export type GetApiRTMGetStatusByPatientIdResult = NonNullable<Awaited<ReturnType<typeof getApiRTMGetStatusByPatientId>>>
export type GetApiRTMGetEnrollmentInfoResult = NonNullable<Awaited<ReturnType<typeof getApiRTMGetEnrollmentInfo>>>
export type PostApiRTMCompleteEnrollmentResult = NonNullable<Awaited<ReturnType<typeof postApiRTMCompleteEnrollment>>>
export type GetApiRTMGetCheckInQuestionsResult = NonNullable<Awaited<ReturnType<typeof getApiRTMGetCheckInQuestions>>>
export type PostApiRTMSubmitCheckInAnswersResult = NonNullable<Awaited<ReturnType<typeof postApiRTMSubmitCheckInAnswers>>>
export type GetApiSettingsGetIntakeFormSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetIntakeFormSettings>>>
export type GetApiSettingsGetInsuranceSettingsResult = NonNullable<Awaited<ReturnType<typeof getApiSettingsGetInsuranceSettings>>>
export type PostApiTelehealthGetPatientJoinInfoResult = NonNullable<Awaited<ReturnType<typeof postApiTelehealthGetPatientJoinInfo>>>
export type GetApiTempoTokenGetQuestionsResult = NonNullable<Awaited<ReturnType<typeof getApiTempoTokenGetQuestions>>>
export type PostApiTempoTokenSubmitAnswersResult = NonNullable<Awaited<ReturnType<typeof postApiTempoTokenSubmitAnswers>>>
